<template>
    <div class="page-header">
        <div class="title-container">
            <sy-svg-icon v-if="showBack" class="back-icon" icon="back" @click="handleClick" />
            <div class="title">
                <slot>{{ title }}</slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SyPageHeader',
    props: {
        /**
         * 标题
         */
        title: {
            type: String,
            default: '详情页'
        },
        /**
         * 显示返回按钮
         */
        showBack: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        /**
         * 返回事件
         */
        handleClick() {
            this.$emit('back');
        }
    }
};
</script>

<style lang="scss" scoped>
.page-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 46px;
    margin-bottom: 24px;
    padding: 0 16px;
    border-bottom: 1px solid #f5f5f5;

    .title-container {
        display: flex;
        font-size: 16px;

        .back-icon {
            margin-right: 24px;
            color: #1890ff;
            cursor: pointer;
        }

        .title {
            font-weight: bold;
        }
    }
}
</style>
